import Broadcast from '../pages/Dashboard/Alarm/Broadcast/Broadcast';

export const ROUTE = {
  login: '/login',
  accountSettings: '/account-settings',
  logout: '/logout',
  home: '/',
  notification: '/notifications',
  dashboard: '/dashboard',
  trips: '/trips',
  support: '/support',
  helpDesk: 'helpdesk',
  helpDeskDetail: 'helpdesk/:id',
  troubleshoot: 'troubleshoot',
  ignition: '/ignition',
  ignitionTrips: '/trips/ignition',
  ignitionTripsDetails: 'details',
  reports: '/reports-all',
  scheduledReports: '/scheduled-reports',
  createCustomReport: 'create-custom-report',
  customReportDetails: 'report-detail/:report_id/:date_time',
  customReportDetailsEdit: 'edit-detail/:report_id/:date_time',
  managerReport: 'managerReport',
  alarmReport: 'alarmReport',
  newGroup: 'new',
  addGroupVehicles: 'group/vehicles',
  driverPerformanceReport: 'driverPerformanceReport',
  deviceIgnitionReport: 'deviceIgnitionReport',
  deviceHealthReport: 'deviceHealthReport',
  dailyKmReport: 'dailyKmReport',
  groupDetail: ':groupId',
  dailyRunReport: 'dailyRunReport',
  dailyEventReport: 'dailyEventReport',
  nightDriveReport: 'nightDriveReport',
  cameraBlockReport: 'cameraBlockReport',
  continousDrivingReport: 'continousDrivingReport',
  stoppageReport: 'stoppageReport',
  geoFencingReport: 'geoFencingReport',
  eLockUnlockReport: 'eLockUnlockReport',
  tripVehicleSummary: 'tripVehicleSummary',
  passengerReport: 'passengerOccupancyReport',
  driverDailyRunReport: 'driver-daily-run-report',
  driverAttendanceReport: 'driver-attendance-report',
  // driverNextWeekOffReport: 'driver-next-week-off-report',
  newTrips: 'new',
  newRoute: 'new',
  newGeofence: 'new',
  editGeofence: 'edit/:geofenceId',
  addressDetail: ':addressId',
  newAddress: 'new',
  tripDetails: 'details',
  newDriver: 'new',
  reconstruction: 'reconstruction',
  iginitionReconstruction: 'ignition/reconstruction',
  mileStone: 'milestone',
  map: 'map',
  driver: 'drivers',
  myDrivers: 'my-drivers',
  performance: 'performance',
  performanceDriverTable: 'performance/table/:id',
  driverPerformanceDetail: 'performance/:driverId',
  driverDetail: ':id',
  directories: '/directories',
  groups: 'groups',
  routes: 'routes',
  editAddress: 'edit/:id',
  routesDetails: ':id',
  addresses: 'addresses',
  geofences: 'geofences',
  addressesDetails: 'details',
  vehicles: 'vehicles',
  vehiclesDashboard: 'dashboard',
  newVehicle: 'new',
  VehicleDetails: 'details',
  vehicleVideos: 'videos-playback',
  devices: 'devices',
  DeviceDetails: 'details',
  AddDevice: 'add',
  EditDevice: 'edit/:id',
  knowledgeCentre: 'knowledgeCentre',
  Alarm: '/alarm',
  VehicleAlerts: 'vehicle-alerts',
  DriverAlerts: 'driver-alerts',
  DriverCoaching: 'driver-coaching',
  DriverPerformance: 'driver-performance',
  VehicleAllAlerts: 'vehicle-all-alerts',
  VehicleAlertDetails: 'vehicle-alert-details',
  editGroup: 'edit/:id',
  DriverAlertDashboard: 'driver-alert-dashboard',
  SosModal: '/sosModal',
  LiveVideoExtModal: 'liveVideoExtModal',
  VideoSection: 'knowledgeCentre/VideoSection',
  Articles: 'knowledgeCentre/Articles',
  TripsAllAlerts: '/trips/ignition/trip-all-alerts',
  ViewArticles: 'knowledgeCentre/Articles',
  FaqsViewAll: 'knowledgeCentre/FAQsViewAll',
  admin: '/admin',
  customization: 'customization',
  deviceLogs: 'device-logs',
  deviceUpdates: 'device-updates',
  userAccount: 'user-account',
  manageAlerts: 'manage-alerts',
  userSettings: 'user-settings',
  liveStreamConfig: 'live-stream-config',
  userBannerCreate: 'create-banner',
  DriverCoachingDashboard: 'driver-coaching-dashboard/:id',
  DriverCoachingPlaylistDetails: 'driver-coaching-playlist-details',
  Broadcast: 'broadcast',
  newBroadcast: 'new',
  broadcastDetail: ':id',
  editBroadcast: 'edit/:id',
  duplicateBroadcast: 'duplicate/:id',
  userAccessControls: 'user-access-controls',
  document: 'document',
  ApiDocumentation: 'api-documentation',
  UserCreation: 'user-creation',
  CompanyScreen: '/admin/user-creation/company',
  UserScreen: '/admin/user-creation/user',
  CreateCompany: '/admin/user-creation/company/createcompany',
  EditCompany: '/admin/user-creation/company/editcompany',
  CreateUser: '/admin/user-creation/user/createuser',
  manageSubscriptions: 'channel-subscriptions',
  createNewSubscription: 'create',
  renewSubscription: 'renew-subscription',
  internalSubscriptions: 'internal-subscriptions',
  createNewInternalSubscription: 'create',
  analytics: '/analytics',
  myExpenses: '/my-expenses',
  maintenance: '/maintenance',
  serviceSchedules: 'service-schedules',
  serviceHistory: 'service-history',
  serviceHistoryDetails: 'service-history/detail',
  scheduleServiceDetail: 'service-schedules/detail',
  fleetGPT: '/controltower',
  controlTowerReports: '/controltower/reports',
  serviceMaster: 'service-manager',
} as const;

export default ROUTE;
